import { gql } from '@apollo/client'

const UpdateRoomTags = gql`
    mutation UpdateRoomTags($roomId: ID!, $trackId: ID!, $tags: [String!]!) {
        updateRoomTags(roomId: $roomId, trackId: $trackId, tags: $tags) {
            id
            album
            artist
            bitRate
            codec
            completed
            composer
            contributors {
                id
                username
            }
            coverArt {
                full
                thumb250
                thumb500
                thumb1200
            }
            created
            date
            duration
            files {
                bitRate
                duration
                key
                size
            }
            genre
            globalTags
            roomId
            size
            tags
            title
            track
            updated
            userId
            youtubeId
        }
    }    
`

export default UpdateRoomTags

